(function () {

    'use strict';

    angular.module('itxApp.common')
        .factory('ItxSizeGuideSvc', ItxSizeGuideSvc);

    ItxSizeGuideSvc.$inject = ['ngDialog'];

    /**
     * Size guide service helper
     * @constructor
     */
    function ItxSizeGuideSvc(ngDialog) {

        var _this = this;
        _this.newApiSkuDimensions = true;

        _this.uniqByVanillaJS = function (arr, key) {
            return Object.values(
                arr.reduce((map, item) => {
                    if (map) {
                        map[`${item[key]}`] = item;
                        return map;
                    }
                }, {})
            );
        };

        return {
            isGarmentMeasurementsActive: isGarmentMeasurementsActive,
            hasSkuDimensions: hasSkuDimensions,
            isUniqueSize: isUniqueSize,
            openPopup: openPopup,
            removeDuplicates: removeDuplicates,
            productHasSizes: productHasSizes
        };

        function isGarmentMeasurementsActive() {
            var res = false;
            inditex.getXconfiguracionValue('PRODUCT_DIMESIONS', function(status, value) {
                res = value && value !== '0';
            });  
            return res;
        }

        function isUniqueSize(product,selectedColorIndex) {
            var sizes;
            var uniqueSize = false;
            if(!selectedColorIndex){
                selectedColorIndex = 0;
            }
            if (product && product.activeDetail.colors && product.activeDetail.colors.length) {
                sizes = removeDuplicates(product.activeDetail.colors[product.state.selectedColorIndex].sizes);
                if (sizes.length === 1 && sizes[0].name === '01') {
                    uniqueSize = true;
                }
            }
            return uniqueSize;
        }

        function openPopup(product, name) {
            var tag = '<product-size-guide route-active="\'' + name + '\'" product="ngDialogData.product"></product-size-guide>';
            return ngDialog.open({
                template: tag,
                plain: true,
                className: ' ngdialog-theme-plain new-modal ma-modal-lg  modal-product-size-guide ' + name,
                showClose: true,
                data: {
                    product: product
                }
            });
        }

        function hasSkuDimensions(product) {
            var response = false;
            _.each(product.activeDetail.colors, function(color){
                if(color.sizes[0].skuDimensions && color.sizes[0].skuDimensions.length > 0){
                    response = true;
                    return;
                }                    
            });
            return response;
        }
        
        function removeDuplicates(originalSizes) {
            var result = [], sizesWithoutDups;
            
            var priority = {
                'disabled': -1,
                'hidden': 0,
                'sold_out': 1,
                'coming_soon': 2,
                'back_soon': 3,
                'show': 4
            };

            // _.uniqBy(originalSizes, function (size) {
            //     return size.name;
            // });
            sizesWithoutDups = _this.uniqByVanillaJS(originalSizes, 'name');

            _.each(sizesWithoutDups, function (size) {
                if (size.visibility !== 'show') {
                    var firstVisibleSize = _.find(originalSizes, function (s) {
                        return (s.name === size.name) && priority[s.visibility] > priority[size.visibility];
                    });

                    if (firstVisibleSize) {
                        result.push(firstVisibleSize);
                    } else {
                        result.push(size);
                    }
                } else {
                    result.push(size);
                }
            });
            return result;
        }

        // @arraySizes [Strings...]
        // @products [Objects...]
        // @return [Objects...] type product
        function productHasSizes(arraySizes, products) {
            if(arraySizes.length) {
                products = _.filter(products, function(product) {
                    return _oneSize(product, arraySizes);
                });
            } 
            return products;
        }

        // @product {Object}
        // @arraySize [String];
        // @return {Object} type product
        function _oneSize(product, arraySize){
            var color = product.state.selectedColor;
            if(product.isBundleBean) {
                return false;
            } else {
                return _.find(color.sizes, function(size) {
                    if(arraySize.indexOf(size.name) > -1){
                        return size.visibility !== 'hidden';
                    }
                });
            }
        }

    }

})();
